"use strict";

var _interopRequireDefault3 = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault3(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault3(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault3(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault3(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault3(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault3(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault3(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault3(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireDefault2 = _interopRequireDefault3(require("@babel/runtime/helpers/interopRequireDefault"));

var _autobindDecorator = _interopRequireDefault3(require("autobind-decorator"));

var _Checkbox = _interopRequireDefault3(require("../../Checkbox/js/Checkbox"));

var _classnames = _interopRequireDefault3(require("classnames"));

var _createId = _interopRequireDefault3(require("../../utils/createId"));

var _filterDOMProps = _interopRequireDefault3(require("../../utils/filterDOMProps"));

var _intl = require("../../utils/intl");

var _propTypes = _interopRequireDefault3(require("prop-types"));

var _react = _interopRequireDefault3(require("react"));

require("../style/index.css");

var _class, _class2, _temp;

var intlMessages = {
  "cs-CZ": (0, _interopRequireDefault2["default"])(require("./../intl/cs-CZ.json"))["default"],
  "da-DK": (0, _interopRequireDefault2["default"])(require("./../intl/da-DK.json"))["default"],
  "de-DE": (0, _interopRequireDefault2["default"])(require("./../intl/de-DE.json"))["default"],
  "en-US": (0, _interopRequireDefault2["default"])(require("./../intl/en-US.json"))["default"],
  "es-ES": (0, _interopRequireDefault2["default"])(require("./../intl/es-ES.json"))["default"],
  "fi-FI": (0, _interopRequireDefault2["default"])(require("./../intl/fi-FI.json"))["default"],
  "fr-FR": (0, _interopRequireDefault2["default"])(require("./../intl/fr-FR.json"))["default"],
  "hu-HU": (0, _interopRequireDefault2["default"])(require("./../intl/hu-HU.json"))["default"],
  "it-IT": (0, _interopRequireDefault2["default"])(require("./../intl/it-IT.json"))["default"],
  "ja-JP": (0, _interopRequireDefault2["default"])(require("./../intl/ja-JP.json"))["default"],
  "ko-KR": (0, _interopRequireDefault2["default"])(require("./../intl/ko-KR.json"))["default"],
  "nb-NO": (0, _interopRequireDefault2["default"])(require("./../intl/nb-NO.json"))["default"],
  "nl-NL": (0, _interopRequireDefault2["default"])(require("./../intl/nl-NL.json"))["default"],
  "pl-PL": (0, _interopRequireDefault2["default"])(require("./../intl/pl-PL.json"))["default"],
  "pt-BR": (0, _interopRequireDefault2["default"])(require("./../intl/pt-BR.json"))["default"],
  "ru-RU": (0, _interopRequireDefault2["default"])(require("./../intl/ru-RU.json"))["default"],
  "sv-SE": (0, _interopRequireDefault2["default"])(require("./../intl/sv-SE.json"))["default"],
  "tr-TR": (0, _interopRequireDefault2["default"])(require("./../intl/tr-TR.json"))["default"],
  "uk-UA": (0, _interopRequireDefault2["default"])(require("./../intl/uk-UA.json"))["default"],
  "zh-CN": (0, _interopRequireDefault2["default"])(require("./../intl/zh-CN.json"))["default"],
  "zh-TW": (0, _interopRequireDefault2["default"])(require("./../intl/zh-TW.json"))["default"]
};

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/card/index.css");

  require("../../spectrum-css/card/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/card/index-lg.css");
} else {
  require("../../spectrum-css/card/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/card/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/card/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/card/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/card/multiStops/darkest.css");

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/quickaction/index.css");

  require("../../spectrum-css/quickaction/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/quickaction/index-lg.css");
} else {
  require("../../spectrum-css/quickaction/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/quickaction/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/quickaction/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/quickaction/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/quickaction/multiStops/darkest.css");
var formatMessage = (0, _intl.messageFormatter)(intlMessages);

var Card = (0, _autobindDecorator["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Card, _React$Component);

  function Card(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Card);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Card).call(this, props));
    _this.cardId = (0, _createId["default"])();
    return _this;
  } // Determine if the CardBody has a title, subtitle or description.
  // This is used in CardPreview to decide whether to default the
  // image to decorative for accessibility.


  (0, _createClass2["default"])(Card, [{
    key: "getCardBody",
    value: function getCardBody() {
      return _react["default"].Children.toArray(this.props.children).find(function (child) {
        return child.type.displayName === 'CardBody';
      });
    }
  }, {
    key: "hasTitle",
    value: function hasTitle() {
      var cardBody = this.getCardBody();
      return Boolean(cardBody && cardBody.props.title);
    }
  }, {
    key: "hasSubtitle",
    value: function hasSubtitle() {
      var cardBody = this.getCardBody();
      return Boolean(cardBody && cardBody.props.subtitle);
    }
  }, {
    key: "hasDescription",
    value: function hasDescription() {
      var cardBody = this.getCardBody();
      return Boolean(cardBody && cardBody.props.description);
    }
  }, {
    key: "getAriaProps",
    value: function getAriaProps() {
      var _this$props = this.props,
          _this$props$id = _this$props.id,
          id = _this$props$id === void 0 ? this.cardId : _this$props$id,
          ariaLabel = _this$props['aria-label'],
          ariaLabelledby = _this$props['aria-labelledby'],
          ariaDescribedby = _this$props['aria-describedby'];

      if (!ariaLabelledby && !ariaLabel) {
        var ids = [];
        this.hasSubtitle() && ids.push("".concat(id, "-subtitle"));
        this.hasDescription() && ids.push("".concat(id, "-description"));

        if (this.hasTitle()) {
          ariaLabelledby = "".concat(id, "-title");

          if (!ariaDescribedby) {
            ariaDescribedby = ids.join(' ');
          }
        } else if (this.hasSubtitle()) {
          ariaLabelledby = "".concat(id, "-subtitle");

          if (!ariaDescribedby && this.hasDescription()) {
            ariaDescribedby = "".concat(id, "-description");
          }
        } else {
          if (ids.length) {
            ariaLabelledby = ids.join(' ');
          }
        }
      }

      return {
        ariaLabel: ariaLabel,
        ariaLabelledby: ariaLabelledby,
        ariaDescribedby: ariaDescribedby
      };
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      var _this$props2 = this.props,
          actionMenu = _this$props2.actionMenu,
          _this$props2$id = _this$props2.id,
          id = _this$props2$id === void 0 ? this.cardId : _this$props2$id;
      var hasTitle = this.hasTitle();

      if (this.props.size === 'S') {
        actionMenu = null;
      }

      return {
        cardVariant: this.props.variant,
        cardSize: this.props.size,
        actionMenu: actionMenu,
        onLoad: this.props.onLoad,
        hasTitle: hasTitle,
        id: id
      };
    }
  }, {
    key: "handleCheckboxClick",
    value: function handleCheckboxClick(evt) {
      if (this.props.onSelectionChange) {
        evt.stopPropagation();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getAriaProps = this.getAriaProps(),
          ariaLabel = _this$getAriaProps.ariaLabel,
          ariaLabelledby = _this$getAriaProps.ariaLabelledby,
          ariaDescribedby = _this$getAriaProps.ariaDescribedby;

      var _this$props3 = this.props,
          variant = _this$props3.variant,
          size = _this$props3.size,
          selected = _this$props3.selected,
          allowsSelection = _this$props3.allowsSelection,
          isDropTarget = _this$props3.isDropTarget,
          quickActions = _this$props3.quickActions,
          actionMenu = _this$props3.actionMenu,
          children = _this$props3.children,
          className = _this$props3.className,
          _this$props3$role = _this$props3.role,
          role = _this$props3$role === void 0 ? 'region' : _this$props3$role,
          _this$props3$id = _this$props3.id,
          id = _this$props3$id === void 0 ? this.cardId : _this$props3$id,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props3, ["variant", "size", "selected", "allowsSelection", "isDropTarget", "quickActions", "actionMenu", "children", "className", "role", "id"]); // Small size is not supported for standard cards

      if (variant === 'standard' && size === 'S') {
        size = 'L';
      }

      var checkbox = null;

      if (allowsSelection) {
        var label = selected ? 'selected' : 'select';
        checkbox = _react["default"].createElement("div", {
          className: (0, _classnames["default"])('spectrum-QuickActions', 'spectrum-Card-quickActions')
        }, _react["default"].createElement(_Checkbox["default"], {
          onChange: this.props.onSelectionChange,
          onClick: this.handleCheckboxClick,
          checked: selected,
          id: "".concat(id, "-checkbox"),
          title: formatMessage('select'),
          "aria-label": "(".concat(formatMessage(label), ")"),
          "aria-labelledby": ariaLabelledby ? "".concat(ariaLabelledby, " ").concat(id, "-checkbox") : undefined,
          "aria-hidden": !selected || undefined
        }));
      }

      if (ariaLabelledby && selected) {
        ariaLabelledby = "".concat(ariaLabelledby, " ").concat(id, "-checkbox");
      }

      if (quickActions && actionMenu) {
        throw new Error('Either quick actions or an action button can be passed to Card, not both.');
      }

      if (size === 'S' && actionMenu) {
        quickActions = _react["default"].createElement("div", {
          className: "spectrum-QuickActions spectrum-Card-actions"
        }, actionMenu);
      }

      var assetClass = (0, _classnames["default"])('spectrum-Card', "spectrum-Card--".concat(variant), {
        'spectrum-Card--large': size === 'L',
        'spectrum-Card--small': size === 'S',
        'is-selected': selected,
        'is-drop-target': isDropTarget
      }, className);
      return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _filterDOMProps["default"])(otherProps), {
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        role: role,
        className: assetClass
      }), children, checkbox, quickActions);
    }
  }]);
  return Card;
}(_react["default"].Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /** Card variant */
  variant: _propTypes["default"].oneOf(['standard', 'quiet', 'gallery']),

  /** Card can be large or small size */
  size: _propTypes["default"].oneOf(['S', 'L']),

  /** Whether or not the card supports selection */
  allowsSelection: _propTypes["default"].bool,

  /** Whether or not the card is selected */
  selected: _propTypes["default"].bool,

  /** What happens when the checkbox is clicked */
  onSelectionChange: _propTypes["default"].func,

  /** Whether the card is currently a drop target */
  isDropTarget: _propTypes["default"].bool,

  /** Quick actions to display on the card. */
  quickActions: _propTypes["default"].element,

  /** Action menu to display in the body of the card. */
  actionMenu: _propTypes["default"].element
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  variant: 'standard',
  size: 'L',
  selected: false,
  allowsSelection: true
}), (0, _defineProperty2["default"])(_class2, "childContextTypes", {
  cardVariant: _propTypes["default"].string,
  cardSize: _propTypes["default"].string,
  actionMenu: _propTypes["default"].element,
  onLoad: _propTypes["default"].func,
  hasTitle: _propTypes["default"].bool,
  id: _propTypes["default"].string
}), _temp)) || _class;

exports["default"] = Card;